<template>
  <div
    v-if="isVisible"
    class="select-object"
    :class="{ 'highlighted-box': badObject }"
    :style="{
      border: getColorForBorder(state),
      'background-color': getColorForBackgroundColor(state),
      'box-shadow': getColorForBoxShadow(state),
      color: getColorForText(state)
    }"
  >
    {{ message }}
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
      :size="17"
      :width="2"
    />
  </div>
</template>

<script>
export default {
  name: "HighlightedBox",

  props: {
    badObject: {
      type: Boolean,
      default: false
    },

    isVisible: {
      type: Boolean,
      required: true
    },

    message: {
      type: String
    },

    state: {
      type: String,
      default: "selected"
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ///////////////////////////////
    /* Style For Message Box */
    ///////////////////////////////

    getColorForBorder(state) {
      switch (state) {
        case "selected":
          return "1px dashed var(--primary-highlight)";
        case "success":
          return "1px dashed rgba(65, 117, 5)";
        case "fail":
          return "1px dashed rgba(147, 0, 18)";
        case "warning":
          return "1px dashed rgba(230, 153, 43)";
      }
    },

    getColorForBackgroundColor(state) {
      switch (state) {
        case "selected":
          return "rgba(227, 240, 243, 1)";
        case "success":
          return "rgba(65, 117, 5, 0.2)";
        case "fail":
          return "rgba(147, 0, 18, 0.2)";
        case "warning":
          return "rgba(235, 210, 111, 0.2)";
      }
    },

    getColorForBoxShadow(state) {
      switch (state) {
        case "selected":
          return "0 0 4px rgba(81, 203, 238, 1)";
        case "success":
          return "0 0 4px rgba(65, 117, 5, 1)";
        case "fail":
          return "0 0 4px rgba(147, 0, 18, 1)";
        case "warning":
          return "0 0 4px rgba(230, 153, 43, 1)";
      }
    },

    getColorForText(state) {
      switch (state) {
        case "selected":
          return "rgba(106, 177, 194, 1)";
        case "success":
          return "rgba(65, 117, 5, 1)";
        case "fail":
          return "rgba(147, 0, 18, 1)";
        case "warning":
          return "rgba(230, 153, 43, 1)";
      }
    }
  }
};
</script>

<style scoped>
.select-object {
  border: 1px dashed var(--primary-highlight);
  background-color: rgba(227, 240, 243, 1);
  height: auto;
  min-height: 40px;
  display: flex;
  justify-content: center;
  padding: 5px 10px;
  align-items: center;
  color: rgba(106, 177, 194, 1);
  margin-top: 25px;
  transition: box-shadow 300ms linear;
}
.highlighted-box {
  transition: box-shadow 200ms linear;
  animation: shake 0.5s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/_Molecules/HighlightedBox.vue